import React, { useEffect, useContext } from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import DealingsNavigator from "../../components/DealingsNavigator";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";

const EMPTY_UPDATE = {
    legalBasisForChanges: null,
    changeReasonDescription: null,
    updatedOrderDescription: null,
    contractChangeValue: null,
    currencyCode: null,
    priceIncreaseDueToChange: null,
};

function ContractUpdates(
    {
        id,
        formikProps
    }) {
    const { getDict } = useContext(FormTranslationContext);
    const updatesId = id + ".contractUpdates";
    const updates = getObjectValue(updatesId, formikProps.values, []);
    const updateCount = getObjectValue(id + ".updateCount", formikProps.values, 0) || 0;
    const curIndex = getObjectValue('contractUpdateDealing', formikProps.values, -1);

    useEffect(() => {
        const currentLength = updates.length;
        if (updateCount === currentLength) return;

        let newUpdates;
        if (updateCount > currentLength) {
            newUpdates = [
                ...updates,
                ...Array.from({ length: updateCount - currentLength }, () => ({ ...EMPTY_UPDATE }))
            ];
        } else {
            newUpdates = updates.slice(0, updateCount);
        }
        formikProps.setFieldValue(updatesId, newUpdates);

        if (curIndex >= updateCount) {
            formikProps.setFieldValue('contractUpdateDealing', updateCount > 0 ? 0 : -1);
        }
    }, [updateCount]); // eslint-disable-line react-hooks/exhaustive-deps

    if (updateCount < 1) return null;

    const gId = (name) => updatesId + "." + curIndex + "." + name;

    return (
        <>
            <DealingsNavigator
                formikProps={formikProps}
                id="contractUpdateDealing"
                items={updates}
                partTranslationKey="update_x"
                choosePositionTranslationKey="choose_update"
            />
            {curIndex > -1 && curIndex < updates.length && (
                <>
                    <NoticeGlossaryInput
                        formikProps={formikProps}
                        id={gId("legalBasisForChanges")}
                        items={getDict("SL.MO.050")}
                        required
                    />
                    <NoticeTextInput
                        formikProps={formikProps}
                        id={gId("changeReasonDescription")}
                        multiline
                        required
                    />
                    <NoticeTextInput
                        formikProps={formikProps}
                        id={gId("updatedOrderDescription")}
                        multiline
                        required
                    />
                    <NoticeNumericInput
                        formikProps={formikProps}
                        id={gId("contractChangeValue")}
                        required
                    />
                    <NoticeGlossaryInput
                        formikProps={formikProps}
                        id={gId("currencyCode")}
                        items={getDict("SL.MO.043")}
                        required
                    />
                    <NoticeYesNoInput
                        formikProps={formikProps}
                        id={gId("priceIncreaseDueToChange")}
                        required
                    />
                </>
            )}
        </>
    );
}

ContractUpdates.propTypes = {};

export default ContractUpdates;
